import type { LeaderboardTimeFrame } from '../types/types'

/**
 * Leaderboard TanStack query key factory — keep in sync with leaderboard.query-store usage.
 */
export const leaderboardQueryKeys = {
  all: (groupId?: string) => ['leaderboard', groupId] as const,
  groupLeaderboard: (groupId: string, timeFilter?: LeaderboardTimeFrame) => ['leaderboard', groupId, 'group', timeFilter] as const,
  groupMembersLevelDistribution: (groupId: string) => ['leaderboard', groupId, 'members-level-distribution'] as const,
} as const
